export const ROUTES = {
  HOME: '/home',
  CREATE_POST: '/createPost',
  FEED_LIST: '/feedList',
};

export enum DiscoveryCardType {
  TRENDING = 'Trending',
  CROPS = 'crop-playlists',
  POPULAR = 'Popular',
  MACHINERY = 'machinery-playlists',
  EXPERT = 'Expert',
  GOVTSCHEMES = 'govt-scheme-playlists',
  DAIRY = 'Dairy',
  ANIMALS = 'animal-playlists',
  CONTINUE_WATCHING = 'continue-watching',
  VIDEO_LIST = 'video-list',
  TRENDING_VIDEOS = 'trending-videos',
  BANNER_AD = 'BANNER_AD',
  CAROUSEL = 'carousel',
}
export const LanguageJson = {
  aa: 'Afar',
  ab: 'Abkhazian',
  af: 'Afrikaans',
  ak: 'Akan',
  am: 'Amharic',
  ar: 'Arabic',
  an: 'Aragonese',
  ase: 'American Sign Language',
  as: 'Assamese',
  asq: 'Austrian Sign Language',
  av: 'Avaric',
  avk: 'Kotava',
  ay: 'Aymara',
  az: 'Azerbaijani',
  ba: 'Bashkir',
  bm: 'Bambara',
  be: 'Belarusian',
  bn: 'Bengali',
  bfi: 'British Sign Language',
  bi: 'Bislama',
  bo: 'Tibetan',
  bs: 'Bosnian',
  br: 'Breton',
  bg: 'Bulgarian',
  bzs: 'Brazilian Sign Language',
  ca: 'Catalan',
  cs: 'Czech',
  ch: 'Chamorro',
  ce: 'Chechen',
  cv: 'Chuvash',
  kw: 'Cornish',
  co: 'Corsican',
  cr: 'Cree',
  cse: 'Czech Sign Language',
  csl: 'Chinese Sign Language',
  cy: 'Welsh',
  da: 'Danish',
  de: 'German',
  dv: 'Dhivehi',
  dsl: 'Danish Sign Language',
  dz: 'Dzongkha',
  el: 'Greek',
  en: 'English',
  eo: 'Esperanto',
  et: 'Estonian',
  eu: 'Basque',
  ee: 'Ewe',
  fo: 'Faroese',
  fa: 'Persian',
  fj: 'Fijian',
  fi: 'Finnish',
  fr: 'French',
  fy: 'Western Frisian',
  fse: 'Finnish Sign Language',
  fsl: 'French Sign Language',
  ff: 'Fulah',
  gcf: 'Guadeloupean Creole French',
  gd: 'Scottish Gaelic',
  ga: 'Irish',
  gl: 'Galician',
  gv: 'Manx',
  gn: 'Guarani',
  gsg: 'German Sign Language',
  gu: 'Gujarati',
  ht: 'Haitian',
  ha: 'Hausa',
  sh: 'Serbo-Croatian',
  he: 'Hebrew',
  hz: 'Herero',
  hi: 'Hindi',
  ho: 'Hiri Motu',
  hr: 'Croatian',
  hu: 'Hungarian',
  hy: 'Armenian',
  ig: 'Igbo',
  ii: 'Sichuan Yi',
  iu: 'Inuktitut',
  id: 'Indonesian',
  ik: 'Inupiaq',
  is: 'Icelandic',
  it: 'Italian',
  jv: 'Javanese',
  jbo: 'Lojban',
  ja: 'Japanese',
  jsl: 'Japanese Sign Language',
  kab: 'Kabyle',
  kl: 'Kalaallisut',
  kn: 'Kannada',
  ks: 'Kashmiri',
  ka: 'Georgian',
  kr: 'Kanuri',
  kk: 'Kazakh',
  km: 'Khmer',
  ki: 'Kikuyu',
  rw: 'Kinyarwanda',
  ky: 'Kirghiz',
  kv: 'Komi',
  kg: 'Kongo',
  ko: 'Korean',
  kj: 'Kuanyama',
  ku: 'Kurdish',
  lo: 'Lao',
  la: 'Latin',
  lv: 'Latvian',
  li: 'Limburgan',
  ln: 'Lingala',
  lt: 'Lithuanian',
  lb: 'Luxembourgish',
  lu: 'Luba-Katanga',
  lg: 'Ganda',
  mh: 'Marshallese',
  ml: 'Malayalam',
  mr: 'Marathi',
  mk: 'Macedonian',
  mg: 'Malagasy',
  mt: 'Maltese',
  mn: 'Mongolian',
  mi: 'Maori',
  ms: 'Malay (macrolanguage)',
  my: 'Burmese',
  na: 'Nauru',
  nv: 'Navajo',
  nr: 'South Ndebele',
  nd: 'North Ndebele',
  ng: 'Ndonga',
  ne: 'Nepali (macrolanguage)',
  nl: 'Dutch',
  nn: 'Norwegian Nynorsk',
  nb: 'Norwegian Bokmål',
  no: 'Norwegian',
  ny: 'Nyanja',
  oc: 'Occitan',
  oj: 'Ojibwa',
  or: 'Oriya (macrolanguage)',
  om: 'Oromo',
  os: 'Ossetian',
  pa: 'Panjabi',
  pks: 'Pakistan Sign Language',
  pl: 'Polish',
  pt: 'Portuguese (Brazilian)',
  ps: 'Pushto',
  qu: 'Quechua',
  rm: 'Romansh',
  ro: 'Romanian',
  rsl: 'Russian Sign Language',
  rn: 'Rundi',
  ru: 'Russian',
  sg: 'Sango',
  sdl: 'Saudi Arabian Sign Language',
  sfs: 'South African Sign Language',
  si: 'Sinhala',
  sk: 'Slovak',
  sl: 'Slovenian',
  se: 'Northern Sami',
  sm: 'Samoan',
  sn: 'Shona',
  sd: 'Sindhi',
  so: 'Somali',
  st: 'Southern Sotho',
  es: 'Spanish',
  sq: 'Albanian',
  sc: 'Sardinian',
  sr: 'Serbian',
  ss: 'Swati',
  su: 'Sundanese',
  sw: 'Swahili (macrolanguage)',
  sv: 'Swedish',
  swl: 'Swedish Sign Language',
  ty: 'Tahitian',
  ta: 'Tamil',
  tt: 'Tatar',
  te: 'Telugu',
  tg: 'Tajik',
  tl: 'Tagalog',
  th: 'Thai',
  ti: 'Tigrinya',
  tlh: 'Klingon',
  to: 'Tonga (Tonga Islands)',
  tn: 'Tswana',
  ts: 'Tsonga',
  tk: 'Turkmen',
  tr: 'Turkish',
  tw: 'Twi',
  ug: 'Uighur',
  uk: 'Ukrainian',
  ur: 'Urdu',
  uz: 'Uzbek',
  ve: 'Venda',
  vi: 'Vietnamese',
  wa: 'Walloon',
  wo: 'Wolof',
  xh: 'Xhosa',
  yi: 'Yiddish',
  yo: 'Yoruba',
  za: 'Zhuang',
  zh: 'Chinese',
  zu: 'Zulu',
  zxx: 'No linguistic content',
  tok: 'Toki Pona',
  'pt-PT': 'Portuguese (Portugal)',
  'zh-Hans': 'Simplified Chinese',
  'zh-Hant': 'Traditional Chinese',
  'ca-valencia': 'Valencian',
};

export const LanguageFilterJson = [
  { name: 'English', value: 'en' },
  { name: 'हिंदी', value: 'hi' },
  { name: 'मराठी', value: 'mr' },
  { name: 'தமிழ்', value: 'ta' },
  { name: 'తెలుగు', value: 'te' },
  { name: 'اردو', value: 'ur' },
  { name: 'বাংলা', value: 'bn' },
  { name: 'ગુજરાતી', value: 'gu' },
  { name: 'ಕನ್ನಡ', value: 'kn' },
  { name: 'മലയാളം', value: 'ml' },
  { name: 'ਪੰਜਾਬੀ', value: 'pa' },
  { name: 'ଓଡ଼ିଆ', value: 'or' },
];